var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex location"},[_c('v-checkbox',{staticClass:"checkbox",attrs:{"background-color":"white","hide-details":"","color":"success"},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}}),_c('p',{staticClass:"location-item"},[_vm._v(_vm._s(_vm.item))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }